// Browser fingerprinting utility.
// Used for two purposes:
//   1. Stored in RSVP audit log metadata for debugging (NOT used for identity or dedup)
//   2. Comment thread banning — CommentThread.js checks/writes fingerprint to blockedUsers

// Returns the unmasked WebGL renderer string (e.g. "Adreno (TM) 650").
// Falls back to '' if unavailable (privacy mode, no WebGL support).
const getWebGLRenderer = () => {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) return '';
    const ext = gl.getExtension('WEBGL_debug_renderer_info');
    if (!ext) return '';
    return gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) || '';
  } catch { return ''; }
};

// SHA-256 hash of an arbitrary string, returned as hex.
const hashString = async (str) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const getBrowserFingerprint = async () => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.textBaseline = 'top';
  ctx.font = '14px Arial';
  ctx.fillText('fingerprint', 2, 2);
  const canvasData = canvas.toDataURL();

  const fingerprint = {
    userAgent:           navigator.userAgent,
    language:            navigator.language,
    platform:            navigator.platform,
    screenResolution:    `${window.screen.width}x${window.screen.height}`,
    colorDepth:          window.screen.colorDepth,
    timezone:            Intl.DateTimeFormat().resolvedOptions().timeZone,
    hardwareConcurrency: navigator.hardwareConcurrency || 0,
    deviceMemory:        navigator.deviceMemory        || 0,
    webglRenderer:       getWebGLRenderer(),
    canvasHash:          await hashString(canvasData),
  };

  return hashString(JSON.stringify(fingerprint));
};
